import { once } from '@ember/runloop';
import Component from '@glimmer/component';
import { IBvStackNavApi } from '..';

interface IArgs {
  panelId: string;
  backPanelId: string;
  title: string;
  delegate: IBvStackNavApi;
}

export default class BvStackNavView extends Component<IArgs> {
  get panel() {
    const { panelId, backPanelId, title } = this.args;
    return { panelId, backPanelId, title };
  }

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    once(this, this._registerWithDelegate);
  }

  _registerWithDelegate() {
    const { delegate } = this.args;
    if (delegate) {
      delegate.actions.register(this.panel);
    }
  }
}
